import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  assessmentDetails,
  getAssessments,
  resendAssessment,
  verifyAssessment,
  startExam,
  examDetails,
  saveExamAnswer
} from "../../Api/assessments";

export const fetchAssessmentsList = createAsyncThunk(
  "assesments/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAssessments();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const VerifyAssessmentCode = createAsyncThunk(
  "verifycode/verify",
  async (assessmentCode, { rejectWithValue }) => {
    try {
      const response = await verifyAssessment(assessmentCode);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const ResendAssessmentCode = createAsyncThunk(
  "resendcode/resend",
  async (resendCode, { rejectWithValue }) => {
    try {
      const response = await resendAssessment(resendCode);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getAssessmentDetails = createAsyncThunk(
  "assesmentdetail/details",
  async (assesmentDetail, { rejectWithValue }) => {
    try {
      const response = await assessmentDetails(assesmentDetail);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getstartExam = createAsyncThunk(
  "assesmentdetail/startExam",
  async (assesmentDetail, { rejectWithValue }) => {
    try {
      const response = await startExam(assesmentDetail);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getexamDetails = createAsyncThunk(
  "assesmentdetail/examDetails",
  async (assesmentDetail, { rejectWithValue }) => {
    try {
      const response = await examDetails(assesmentDetail);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getsaveExamAnswer = createAsyncThunk(
  "assesmentdetail/saveExamAnswer",
  async (assesmentDetail, { rejectWithValue }) => {
    try {
      const response = await saveExamAnswer(assesmentDetail);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);